import React, { useState, useEffect } from 'react';
import { useAuth } from '../context/AuthContext';
import { 
  createCategory, 
  getCategories, 
  updateCategory, 
  deleteCategory
} from '../services/categoryService';
import './Categories.css';

const ICONS = ['🍔', '🚗', '📚', '🎬', '🏥', '🏠', '💡', '📦', '💰', '💼', '📈', '💵', '🛒', '✈️', '🎮', '👕', '🎨', '⚽', '🍕', '☕'];

const Categories = () => {
  const { currentUser } = useAuth();
  const [categories, setCategories] = useState([]);
  const [showForm, setShowForm] = useState(false);
  const [editingCategory, setEditingCategory] = useState(null);
  const [formData, setFormData] = useState({
    name: '',
    type: 'egreso',
    icon: '📦'
  });
  const [filter, setFilter] = useState('all');

  useEffect(() => {
    loadCategories();
  }, [currentUser]);

  const loadCategories = async () => {
    if (currentUser) {
      const cats = await getCategories(currentUser.uid);
      setCategories(cats);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (editingCategory) {
      await updateCategory(editingCategory.id, formData);
    } else {
      await createCategory(currentUser.uid, formData);
    }
    
    setFormData({ name: '', type: 'egreso', icon: '📦' });
    setShowForm(false);
    setEditingCategory(null);
    loadCategories();
  };

  const handleEdit = (category) => {
    setEditingCategory(category);
    setFormData({
      name: category.name,
      type: category.type,
      icon: category.icon
    });
    setShowForm(true);
  };

  const handleDelete = async (id) => {
    if (window.confirm('¿Eliminar esta categoría? Las transacciones existentes mantendrán el nombre de la categoría.')) {
      await deleteCategory(id);
      loadCategories();
    }
  };

  const handleCancel = () => {
    setShowForm(false);
    setEditingCategory(null);
    setFormData({ name: '', type: 'egreso', icon: '📦' });
  };



  const filteredCategories = categories.filter(cat => {
    if (filter === 'all') return true;
    return cat.type === filter;
  });

  return (
    <div className="categories-page">
      <header>
        <h1>🏷️ Categorías</h1>
        <button onClick={() => setShowForm(!showForm)} className="add-btn">
          {showForm ? 'Cancelar' : '+ Nueva Categoría'}
        </button>
      </header>

      {showForm && (
        <form onSubmit={handleSubmit} className="category-form">
          <input
            type="text"
            placeholder="Nombre de la categoría"
            value={formData.name}
            onChange={(e) => setFormData({...formData, name: e.target.value})}
            required
          />

          <select
            value={formData.type}
            onChange={(e) => setFormData({...formData, type: e.target.value})}
          >
            <option value="egreso">Egreso</option>
            <option value="ingreso">Ingreso</option>
          </select>

          <div className="icon-selector">
            <label>Selecciona un ícono:</label>
            <div className="icon-grid">
              {ICONS.map(icon => (
                <button
                  key={icon}
                  type="button"
                  className={`icon-option ${formData.icon === icon ? 'selected' : ''}`}
                  onClick={() => setFormData({...formData, icon})}
                >
                  {icon}
                </button>
              ))}
            </div>
          </div>

          <div className="form-buttons">
            <button type="submit" className="save-btn">
              {editingCategory ? 'Actualizar' : 'Guardar'}
            </button>
            <button type="button" onClick={handleCancel} className="cancel-btn">
              Cancelar
            </button>
          </div>
        </form>
      )}

      <div className="filter-tabs">
        <button 
          className={filter === 'all' ? 'active' : ''} 
          onClick={() => setFilter('all')}
        >
          Todas ({categories.length})
        </button>
        <button 
          className={filter === 'egreso' ? 'active' : ''} 
          onClick={() => setFilter('egreso')}
        >
          Egresos ({categories.filter(c => c.type === 'egreso').length})
        </button>
        <button 
          className={filter === 'ingreso' ? 'active' : ''} 
          onClick={() => setFilter('ingreso')}
        >
          Ingresos ({categories.filter(c => c.type === 'ingreso').length})
        </button>
      </div>



      <div className="categories-grid">
        {filteredCategories.map(category => (
          <div key={category.id || category.name} className={`category-card ${category.type}`}>
            <div className="category-icon">{category.icon}</div>
            <div className="category-info">
              <h3>{category.name}</h3>
              <div className="category-badges">
                <span className="category-type">
                  {category.type === 'ingreso' ? 'Ingreso' : 'Egreso'}
                </span>
                {!category.id && (
                  <span className="default-badge">Por defecto</span>
                )}
              </div>
            </div>
            {category.id && (
              <div className="category-actions">
                <button onClick={() => handleEdit(category)} className="edit-btn">✏️</button>
                <button onClick={() => handleDelete(category.id)} className="delete-btn">🗑️</button>
              </div>
            )}
          </div>
        ))}
      </div>

      <a href="/dashboard" className="back-link">← Volver al Dashboard</a>
    </div>
  );
};

export default Categories;
